<template>
  <div class="flex justify-center">
    <div class="flex flex-col text--postShadow w-full mt-4">
      <div class="flex flex-row">
        <div class="text-gray-400 flex grow flex-col items-start ml-8 mb-2 mt-4">
          <user :user='user' />
          <h2 class="text-white">{{body}}</h2>
        </div>
      </div>

      <!--
      <vote-on-post :id='post.id' 
                    :upvotes='upvotes'
                    :downvotes='downvotes'
                    class='px-2 py-1 self-center w-24 flex justify-around px-1 md:px-2' />
      -->

    </div>


  </div>

          <!--
          <p class="text-center mb-2">Comments</p>
          -->
</template>
<script>
//import CommentMultipleOutline from '@icons/CommentMultipleOutline.vue';
import User from '@ui/atoms/User.vue';
//import VoteOnPost from '@ui/molecules/VoteOnPost.vue';
//import Post from '@icons/Post.vue';
import EventEmitter from 'eventemitter3';
export default {
  inject: ['api'],
  props: {
    id: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    upvotes: {
      type: Number,
      required: true
    },
    downvotes: {
      type: Number,
      required: true
    },
    parent: {
      type: Object,
      default() {
        return {
          id: 'root'
        }
      }
    },
    post:{
      type:Object,
      default() {
        return {}
      }
    },
    replies:{
      type:Object,
      default() {
        return {
          total: 0
        }
      }
    }
  },
  mounted() {
  },
  components: {
    //Post,
    User,
    //CommentMultipleOutline
    //VoteOnPost
  },
  methods:{
  },
  computed: {
  }
}
</script>

<style scoped>

.text--postShadow {
  @apply shadow-lg;
}

</style>
